var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGptSideBarHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_2674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75562 6.84895H3.39202L3.79231 6.44164H5.53095V6.40369H3.77677L3.37648 6.81099H1.75562V6.84895Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75562 6.65288H3.0045L3.72185 5.92332H5.14585V5.88501H3.70631L2.98896 6.61493H1.75562V6.65288Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21425 6.32788H1.7915V6.36584H2.21425V6.32788Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80469 6.06463H2.22225L3.23801 5.03143H5.37728L7.16392 3.21349H7.45611V3.17554H7.14838L5.36174 4.99313H3.22247L2.20671 6.02668H1.80469V6.06463Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88918 5.36068L2.49325 4.75728H5.23452L9.07651 0.848341H9.77279L10.21 0.403433H11.165V0.365479H10.1945L9.75725 0.810387H9.06097L5.21898 4.71933H2.47805L1.86328 5.33362L1.88918 5.36068Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16479 4.51899H5.09015L8.22239 1.33188L8.19614 1.30518L5.07461 4.48103H2.16479V4.51899Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52217 0.558716H8.4028L5.05988 3.96019H2.38354V3.99815H5.07542L8.41834 0.597022H9.53771",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75195 3.46225H5.2145L7.45601 1.18113L7.42976 1.15442L5.19896 3.4243H2.75195V3.46225Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49057 12.156H1.52787V11.6527L1.11307 11.2307H0.565297L0.205758 10.8648V10.6055H0.168457V10.8806L0.5501 11.2686H1.09752L1.49057 11.6685V12.156Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03806 12.8627L2.06431 12.8356L1.74829 12.514H1.51758V12.552H1.73275L2.03806 12.8627Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63086 13.8017H1.66816V13.3258L1.95275 13.0366H2.35166V12.9983H1.93721L1.63086 13.31V13.8017Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79731 15.2527H1.83461V14.9941L2.01109 14.8142V14.2536L1.75379 13.9918L1.72754 14.0189L1.97379 14.2694V14.7983L1.79731 14.9783V15.2527Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8689 15.602H3.92355L4.615 14.8984L4.58875 14.8717L3.90801 15.564H1.8689V15.602Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3252 15.9774H3.97092L4.76944 15.1649L4.74284 15.1382L3.95538 15.9394H2.3252V15.9774Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24023 16.5902H8.88562L9.68413 15.7777L9.65788 15.751L8.87007 16.5522H7.24023V16.5902Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95456 10.8402L1.98081 10.8132L1.49693 10.3208H0.361328V10.3588H1.48139L1.95456 10.8402Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71576 10.0803H0.591553V10.1183H1.71576V10.0803Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53518 9.85059H0.760498V9.88854H1.53518V9.85059Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.48826 8.69783L1.79841 8.38225V7.8407H1.76111V8.36644L1.46167 8.67112L1.48826 8.69783Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21583 7.6031L3.24207 7.57639L2.93054 7.2594H1.82153V7.29735H2.915L3.21583 7.6031Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74885 7.53918H1.87573V7.57714H2.74885V7.53918Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63554 8.51333L3.66179 8.48662L2.95307 7.76514H2.32206L2.1062 7.98443L2.13245 8.01149L2.33726 7.80309H2.93753L3.63554 8.51333Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57886 9.03598H2.97984L3.24198 8.76925L3.21574 8.74219L2.96464 8.99768H2.57886V9.03598Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85828 3.21024L4.69328 1.3431L4.66703 1.31604L2.83203 3.18318L2.85828 3.21024Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27562 3.21033L6.03623 0.401358H7.38942V0.363403H6.02069L3.24902 3.18327L3.27562 3.21033Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70447 3.2103L5.92595 0.949912L5.8997 0.922852L3.67822 3.18324L3.70447 3.2103Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26791 0.254395H8.36026L7.92439 0.697546H6.55565L4.11279 3.1832L4.13939 3.21026L6.5712 0.735852H7.93993L8.3758 0.292349H9.28345",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51624 3.21029L6.69834 0.989965L6.67175 0.963257L4.48999 3.18323L4.51624 3.21029Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95545 3.21036L7.15309 0.974218L7.12684 0.94751L4.9292 3.1833L4.95545 3.21036Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09803 9.42106L2.0751 8.42722L2.04851 8.40051L1.07178 9.39435L1.09803 9.42106Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.929688 9.67197H1.72371L2.21691 9.17013L2.19066 9.14307L1.70817 9.63401H0.929688V9.67197Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44603 9.50471L2.21346 8.72384L2.18721 8.69678L1.41943 9.478L1.44603 9.50471Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94007 5.82425L2.7631 4.98679L2.73686 4.96008L1.91382 5.79754L1.94007 5.82425Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2294 8.41319L3.256 8.38648L2.83118 7.95422L2.80493 7.98128L3.2294 8.41319Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97344 11.278L1.99969 11.2509L1.4084 10.6493H0.612305V10.6872H1.39286L1.97344 11.278Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41086 10.9854H0.758789V11.0233H1.41086V10.9854Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47937 12.8672H3.46473V12.8293H2.49491L1.81141 12.1338L1.78516 12.1608L2.47937 12.8672Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54573 12.6022H4.15105V12.5642H2.56093L1.70024 11.6881V11.2703H1.6626V11.7039L2.54573 12.6022Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04773 11.4587H5.11344V11.4207H3.06328L2.09345 10.4339V9.91662L2.5832 9.41829L2.55661 9.39124L2.05615 9.90081V10.4497L3.04773 11.4587Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94184 12.0156H5.34878L6.25816 11.0903H6.41566V11.0524H6.24262L5.33359 11.9773H2.95738L2.28148 11.2896L2.25488 11.3163L2.94184 12.0156Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37988 9.2946H3.18151L3.66158 8.80611L3.63533 8.77905L3.16596 9.25664H2.37988V9.2946Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17819 11.1987L3.20444 11.1716L2.4605 10.4146V9.94021L2.75269 9.64255L2.72644 9.61584L2.42285 9.9244V10.4301L3.17819 11.1987Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9668 9.61749H3.45274L4.26922 8.78672V8.39171L3.74701 7.86035L3.72076 7.88741L4.23192 8.40753V8.7709L3.4372 9.57954H2.9668V9.61749Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94223 8.46621L3.96882 8.4395L3.37132 7.83188L3.73155 7.46534V7.00708H1.72974V7.04539H3.69425V7.44953L3.31848 7.83188L3.94223 8.46621Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53856 6.25547L3.39406 5.38463H5.37619L6.09077 6.11139H7.58177V6.07343H6.10597L5.39173 5.34668H3.37886L2.51196 6.22841L2.53856 6.25547Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85358 6.29477H7.37428V6.25681H5.86913L5.23259 5.60913H3.51261L2.90405 6.22835L2.9303 6.25541L3.52815 5.64709H5.21705L5.85358 6.29477Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35911 6.64378L3.79291 6.20238H5.28322V6.16443H3.77737L3.33252 6.61707L3.35911 6.64378Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81665 9.99501H3.50948L4.57566 8.91015H6.45176V8.87219H4.56012L3.49394 9.95705H2.81665V9.99501Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78474 10.9888H5.31166L6.00311 10.2853H6.41584V10.2473H5.98757L5.29647 10.9509H3.80029L3.38963 10.533L3.36304 10.5597L3.78474 10.9888Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.96873 10.3798L4.82251 9.51108H6.48723V9.47278H4.80697L3.94214 10.3528L3.96873 10.3798Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32471 10.3338H5.0835L5.61608 9.79186H6.41563V9.75391H5.60053L5.06796 10.2958H4.32471V10.3338Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61766 10.1296L4.99067 9.75008L4.96407 9.72302L4.59106 10.1026L4.61766 10.1296Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89849 8.49292H4.49341V8.53087H7.89849V8.49292Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53885 8.24343H7.74223V8.20547H4.55439L3.93616 7.57642L3.90991 7.60312L4.53885 8.24343Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51395 7.34028H7.70827V7.30233H6.52949L5.87258 6.63391H3.91118L3.69946 6.84934L3.72606 6.87605L3.92672 6.67187H5.85704L6.51395 7.34028Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22346 7.62841H7.74244V7.59045H6.239L5.66568 7.00708H3.98438V7.04503H5.65013L6.22346 7.62841Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03067 7.99112H8.18341V7.95281H6.04621L5.48531 7.38245H4.14697V7.4204H5.46977L6.03067 7.99112Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69565 7.97737H5.61505V7.93906H4.71085L4.37376 7.59607L4.34717 7.62278L4.69565 7.97737Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37089 7.66785H4.75024V7.7058H5.37089V7.66785Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79881 6.66516H6.30933V6.70312H8.79881V6.66516Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02926 6.96814H6.62231V7.00609H9.02926V6.96814Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8429 13.6747L2.24665 13.2643L2.22005 13.2375L1.81665 13.648L1.8429 13.6747Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35373 14.8176H3.4883V14.7796H2.39103V14.3294L2.0277 13.9597L2.2515 13.7317L2.22491 13.705L1.97485 13.9597L2.35373 14.3453V14.8176Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03431 15.2604L2.29058 14.9996H3.67209L4.43641 14.2219H6.18644V14.184H4.42087L3.65655 14.9617H2.27503L2.00806 15.2337L2.03431 15.2604Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53931 15.2938H3.84587L4.5539 14.5734H6.3813V14.5354H4.53836L3.83068 15.2558H2.53931V15.2938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.47327 15.7335L5.16644 15.0282L4.84662 14.7028L4.82038 14.7298L5.1136 15.0282L4.44702 15.7064L4.47327 15.7335Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93162 15.6109L5.51808 15.0141L5.21518 14.7059L5.18893 14.7326L5.46523 15.0141L4.90503 15.5838L4.93162 15.6109Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92419 16.1706H9.53732V16.1326H6.93973L6.33083 15.5131H5.24634V15.551H6.31528L6.92419 16.1706Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1307 15.9313H9.38982V15.8934H7.14624L6.58535 15.3226H5.44629V15.3606H6.57015L7.1307 15.9313Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78235 14.7576H5.51196V14.7955H8.78235V14.7576Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46202 14.9993H5.71558V15.0372H8.46202V14.9993Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30928 15.6909H9.2952V15.6526H7.32482L6.94041 15.2615L6.91382 15.2882L7.30928 15.6909Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51861 15.4702H9.26242V15.4323H7.5338L7.36595 15.2615L7.33936 15.2882L7.51861 15.4702Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90919 14.5994H3.67766L4.28656 13.9798H6.33983V13.9419H4.27136L3.66246 14.5615H2.92473L2.36487 13.9918L2.33862 14.0189L2.90919 14.5994Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12129 14.3176H3.59964L4.12876 13.7792H6.22693V13.7409H4.11322L3.5841 14.2796H3.13649L2.39392 13.5237L2.36768 13.5507L3.12129 14.3176Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54913 12.5649H4.71539L4.22806 13.0605H2.84516L2.59131 13.3184L2.6179 13.3455L2.86036 13.0984H4.2436L4.73058 12.6029H5.56467",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99817 13.8989L3.33664 13.5545H4.71401L5.11914 13.1423H6.68785V13.1044H5.10394L4.69847 13.5166H3.3211L2.97192 13.8722L2.99817 13.8989Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2949 14.1319L3.64823 13.7724L3.62163 13.7457L3.26831 14.1049L3.2949 14.1319Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.67951 12.8514H1.29614V12.8894H1.67951V12.8514Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33556 16.9852H10.7482V16.9469H7.35111L6.14746 15.7225H5.39765L5.00426 16.1228H4.46167V16.1608H5.0198L5.41319 15.7605H6.13192L7.33556 16.9852Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32764 15.9644H4.89164L5.11821 15.7335L5.09196 15.7068L4.8761 15.9261H4.32764V15.9644Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89895 17L6.92554 16.9733L6.01409 16.0459H5.44629V16.0842H5.99855L6.89895 17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91899 0H7.61255V0.0383057H9.93453",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70372 16.2585H4.16882V16.2205H2.70372C2.15112 16.2205 1.79641 15.9137 1.64686 15.3093C1.584 15.0545 1.63477 14.9122 1.68416 14.7741C1.71415 14.7009 1.73335 14.6237 1.74115 14.5449L1.7453 14.4869C1.76049 14.2719 1.77534 14.0684 1.5398 13.9155C1.40717 13.8294 1.33809 13.737 1.33499 13.641C1.33084 13.5173 1.4386 13.4235 1.48281 13.3891C1.55983 13.3311 1.56674 13.2794 1.55914 13.246C1.54325 13.1758 1.44827 13.1195 1.30528 13.0932C1.28456 13.09 1.26483 13.082 1.24764 13.0698C1.23044 13.0576 1.21625 13.0416 1.20616 13.0229C1.14779 12.9175 1.17404 12.7027 1.28076 12.4181C1.31254 12.3334 1.40233 12.0406 1.23344 11.8231C1.11153 11.6657 0.980283 11.6056 0.798614 11.5226C0.742662 11.497 0.679113 11.4678 0.610382 11.4334L0.527492 11.3923C0.258096 11.2605 0.0253114 11.1463 0.0373996 10.8064C0.0467248 10.5418 0.29298 10.1981 0.530945 9.86565C0.636631 9.7177 0.746116 9.56483 0.834533 9.41934C1.09391 8.99305 1.39405 8.42058 1.43929 8.19883C1.47383 8.03119 1.47625 7.84318 1.47901 7.62565C1.47901 7.51705 1.48177 7.4046 1.4873 7.28441C1.49075 7.2078 1.49421 7.13505 1.49731 7.06371C1.50698 6.84372 1.51596 6.63602 1.53185 6.39178C1.56889 5.70211 1.71285 5.02273 1.95839 4.3788C2.32795 3.42256 2.90749 2.59389 3.13959 2.28218C3.52261 1.76733 4.06244 1.31364 4.27692 1.14214C4.76045 0.755571 5.65843 0.0383057 7.10902 0.0383057H8.26708V0H7.10833C5.646 0 4.74042 0.72324 4.25412 1.11192C4.03861 1.28412 3.49429 1.74062 3.10989 2.25898C2.8771 2.5721 2.29514 3.40429 1.92386 4.36474C1.67692 5.01226 1.53215 5.69544 1.4949 6.38897C1.47901 6.63497 1.47003 6.84161 1.46036 7.06195C1.45725 7.13224 1.45414 7.20639 1.45034 7.28265C1.44482 7.40354 1.44343 7.51635 1.44205 7.62529C1.43929 7.84072 1.43687 8.02698 1.40303 8.19109C1.3602 8.40195 1.06421 8.96986 0.803104 9.3993C0.715377 9.54374 0.606238 9.69591 0.500897 9.84316C0.259478 10.1802 0.0101147 10.5291 -0.000246618 10.805C-0.013371 11.1698 0.241518 11.2946 0.510913 11.4263L0.593459 11.4671C0.662535 11.5023 0.726775 11.5314 0.783072 11.5571C0.959905 11.6379 1.08735 11.6976 1.20374 11.8463C1.36054 12.0484 1.27524 12.3246 1.24553 12.4044C1.13363 12.7041 1.10738 12.9245 1.17335 13.0415C1.18607 13.0651 1.20396 13.0855 1.22564 13.101C1.24732 13.1164 1.2722 13.1266 1.29838 13.1308C1.42271 13.1536 1.51078 13.2011 1.52253 13.2548C1.53185 13.2949 1.49386 13.3332 1.46036 13.3585C1.40959 13.3968 1.2925 13.5008 1.29734 13.6425C1.30114 13.7517 1.37574 13.8533 1.51942 13.9478C1.73597 14.0884 1.72285 14.2719 1.70765 14.4841L1.7035 14.5425C1.69578 14.6173 1.6774 14.6906 1.64894 14.76C1.60024 14.8967 1.54532 15.0513 1.6106 15.3174C1.76118 15.9334 2.1411 16.2585 2.70372 16.2585Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8473 12.6086L11.0707 14.0143C10.3489 14.4712 9.5269 14.5267 8.69868 14.1609C7.45359 13.6112 6.85574 12.2551 7.22978 10.9326C7.58242 9.68578 8.80229 8.87855 10.083 9.04372C11.3937 9.21311 12.3511 10.3089 12.3728 11.6854C12.3866 12.5664 12.3752 13.4475 12.3752 14.325C11.6827 14.3802 11.1702 13.8723 11.1453 13.1235C11.1284 12.6132 11.1605 12.1004 11.1305 11.5912C11.0832 10.7935 10.3613 10.2055 9.58285 10.2969C8.83165 10.3848 8.27317 11.1189 8.37402 11.8892C8.50838 12.9333 9.70166 13.4661 10.5499 12.8581C10.6559 12.7819 10.7526 12.6905 10.85 12.6093",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3725 8.4146C12.3727 8.50116 12.3557 8.58688 12.3225 8.66657C12.2893 8.74626 12.2406 8.81828 12.1792 8.87826C12.1179 8.93824 12.0452 8.98494 11.9657 9.01555C11.8861 9.04615 11.8012 9.06002 11.7163 9.05631C11.6315 9.05421 11.5479 9.03514 11.4704 9.00018C11.3929 8.96522 11.3229 8.91506 11.2644 8.85256C11.2059 8.79006 11.1601 8.71645 11.1296 8.63594C11.0991 8.55543 11.0845 8.46959 11.0866 8.38332C11.0924 8.20959 11.1648 8.04508 11.2884 7.92506C11.412 7.80503 11.5769 7.73905 11.7477 7.74126C12.1134 7.75251 12.377 8.03752 12.3694 8.4146",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3544 9.271H11.2686C11.2686 9.271 12.2204 9.70114 12.3544 10.2968V9.271Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 15.7394C15.9994 15.7558 15.9953 15.772 15.9875 15.7863C15.9796 15.8007 15.9682 15.8127 15.9545 15.8213C15.3892 16.168 14.6761 16.4499 13.8152 16.6668C12.9338 16.8885 12.0292 17.0004 11.1212 17C9.05773 17 7.44988 16.498 6.29769 15.4941C5.14551 14.4902 4.56988 13.1645 4.5708 11.517C4.5708 10.6049 4.77411 9.7984 5.18074 9.09742C5.56457 8.43557 6.09277 7.87785 6.76534 7.42427C6.77806 7.41571 6.78854 7.40411 6.79585 7.39049C6.80316 7.37687 6.80709 7.36163 6.8073 7.34611C6.8075 7.33059 6.80397 7.31525 6.79702 7.30143C6.79007 7.28762 6.7799 7.27574 6.76741 7.26683C6.49801 7.07284 6.20444 6.7425 5.88669 6.2758C5.52872 5.76242 5.33722 5.14813 5.33892 4.51866C5.33892 3.17808 5.75879 2.08994 6.59852 1.25424C7.43825 0.418545 8.52734 0.000462743 9.8658 -5.82849e-06C10.3872 -0.00281554 10.9076 0.0453167 11.42 0.143728C11.8006 0.218934 12.0576 0.269306 12.1909 0.294843C12.214 0.299276 12.2348 0.311791 12.2497 0.330215C12.2647 0.348639 12.2728 0.371809 12.2727 0.395703V2.36897C12.2727 2.39619 12.2621 2.42229 12.2432 2.44153C12.2243 2.46078 12.1986 2.47159 12.1719 2.47159C12.1638 2.47158 12.1558 2.47052 12.1481 2.46843C11.9512 2.41548 11.6369 2.34519 11.2052 2.25757C10.7943 2.17271 10.3763 2.12845 9.95698 2.12543C9.0682 2.12543 8.38666 2.35339 7.91234 2.80931C7.43802 3.26523 7.20086 3.85341 7.20086 4.57384C7.20086 4.98009 7.33636 5.37474 7.60737 5.7578C7.86686 6.12446 8.12947 6.38217 8.39518 6.53094C8.40672 6.53731 8.41947 6.54111 8.43257 6.54208C8.44567 6.54304 8.45883 6.54117 8.47116 6.53656L12.5857 5.0444C12.7004 5.00186 12.8223 4.98289 12.9443 4.98857C13.0663 4.99426 13.186 5.02449 13.2964 5.07752C13.4069 5.13055 13.5059 5.20533 13.5878 5.29753C13.6697 5.38973 13.7328 5.49753 13.7734 5.6147C13.8141 5.73186 13.8316 5.85607 13.8248 5.98015C13.8181 6.10423 13.7872 6.2257 13.734 6.33757C13.6808 6.44943 13.6064 6.54946 13.515 6.63187C13.4236 6.71428 13.317 6.77744 13.2015 6.81771L9.02964 8.31093C8.16343 8.61737 7.51573 9.0522 7.08654 9.61543C6.65735 10.1787 6.44275 10.8051 6.44275 11.4949C6.44275 12.5063 6.85721 13.3243 7.68611 13.9489C8.51502 14.5735 9.64855 14.8858 11.0867 14.8858C11.8776 14.8858 12.7437 14.7268 13.685 14.4089C14.6115 14.0959 15.3339 13.7475 15.8522 13.3638C15.8681 13.3518 15.8874 13.3454 15.9072 13.3455C15.9321 13.3455 15.956 13.3556 15.9736 13.3735C15.9912 13.3914 16.0011 13.4157 16.0011 13.4411V15.7394H15.9994Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_2674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGptSideBarHover);
export default __webpack_public_path__ + "static/media/gptSideBarHover.03f876a8e310345b0c160bc0722781d4.svg";
export { ForwardRef as ReactComponent };